import React from "react";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

export default function Career() {
  return (
    <div className="slider-wrapper">
      <div className="container">
        <div className="row mt63">
          <div className="col-sm-12">
            <div className="mainbdr whitebg">
              <div className="row">
                <div className="col-sm-3">
                  <Sidebar />
                </div>
                <div class="col-sm-9 " style={{ marginTop: "5px" }}>
                  <div class="row mt0">
                    <div class="col-sm-12">
                      <div class="inner_content contactpage">
                        <h2>BRANDED PRODUCT MIX 1</h2>
                        <div class="clearfix"></div>
                        <div class="tender">
                          {/* <ul>
                            <li class="altcolor">No jobs available. Apply</li>
                          </ul> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <Footer />
            </div>

            <div className="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
